export const handleSortRequest = (orderBy, order, dispatch) => (property) => {
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";
    dispatch({ type: "SET_ORDER", payload: newOrder });
    dispatch({ type: "SET_ORDER_BY", payload: property });
    dispatch({ type: "SET_PAGE", payload: 0 }); // Reset to first page when sorting
  };